export default __webpack_public_path__ + "static/media/card1@3x.63887e58.png";